import React from 'react';
import './legend.scss';

const Legend = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="legend">
      <div className={`legend-content${isOpen ? ' legend-open' : ''}`}>
        <img
          className="legend-image"
          src={
            props.legendImage ||
            'https://dqzrr9k4bjpzk.cloudfront.net/images/12162034/837837040.jpg'
          }
        ></img>
      </div>
      <div className="legend-button esri-widget--button" roll="button" onClick={handleOpen}>
        Legend
      </div>
    </div>
  );
};

export default Legend;
